/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


 import React from 'react';
import linkOutIcon from './link-out-18.svg';
import EDW_CONST from '../../common/constants'
const NoSubscription = () => {
    

    return (<div className="col">
        <div className="row">
                    <div className="col-md-12 course-title">You are not subscribed to this service</div>

                </div>
        <div className="row">
            <div className="card-background no-data">
            <label className="no-data-label">Your school doesn’t currently have a subscription to the Insights dashboard.</label>
            <p>
            Our Insights dashboard enables you to access detailed insights about assessments your students have taken. Find out more about the Insights dashboard at the link below.</p>
            <br />         
            <button className="Button-BG " onClick={() => {window.open(EDW_CONST.MORE_ABOUT_INSIGHTS)}}><img className="icon-adj" src={linkOutIcon} />Find out more about insights</button>
        </div>
    </div>
    </div>
    
    )
}
export default NoSubscription;